import { createAppStore } from '@store/createAppStore';

import { VendorDetailsState } from './types';

const [vendorDetailsStore, setVendorDetailsStore, resetVendorDetailsStore] =
  createAppStore<VendorDetailsState>(
    {
      vendorDetails: {
        operationType: 'Insert',
        id: 0,
        accountingSysVendorId: null,
        name: null,
        currencyType: 'USD',
        phoneNumber: null,
        phoneExtension: null,
        websiteURL: null,
        taxId: null,
        billingTerms: null,
        achRouting: null,
        achAccount: null,
        preferredPaymentType: null,
        preferredPaymentTypeOtherValue: null,
        addressList: [],
        vendorContracts: [],
        operatingLocationList: [],
        billingAddress: null,
        comments: [],
        physicalAddress1: null,
        physicalAddress2: null,
        physicalCity: null,
        physicalState: null,
        physicalZip: null,
        physicalCountryCode: null,
        accountingSysId: null,
      },
      isLoading: false,
      isError: false,
      vendorDocuments: [],
      vendorDetailsErrors: null,
      creationMode: false,
      vendorServiceTypesList: [],
      isSaving: false,
    },
    'vendorDetailsStore',
  );

// @ts-expect-error debug console
window.vendorDetailsStore = { vendorDetailsStore };

export { vendorDetailsStore, setVendorDetailsStore, resetVendorDetailsStore };
